
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"70","height":"70","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"35","cy":"35","r":"35","fill":"#E7896F"}}),_c('path',{attrs:{"d":"M22.453 48h25.1c2.567 0 4.166-2.783 2.883-5l-12.55-21.683c-1.283-2.217-4.483-2.217-5.767 0L19.57 43c-1.283 2.217.317 5 2.884 5zm12.55-11.666c-.917 0-1.667-.75-1.667-1.667v-3.334c0-.916.75-1.666 1.667-1.666.916 0 1.666.75 1.666 1.666v3.334c0 .916-.75 1.666-1.666 1.666zM36.669 43h-3.333v-3.333h3.334V43z","fill":"#fff"}})])
          )
        }
      }
    